<template>
  <div class="backgroud-white cs-courseware-editor">
    <div class="text-center">
      <h6 style="font-size:border">{{ isAdded?'上传新文件': '编辑课件'}}</h6>
    </div>
    <div class="popup-content-area-small">
      <el-form ref="model" :rules="rules" :model="model" label-width="120px" v-loading="isLoadingCourseActivations || loading">
        <el-form-item label="类型">
          <span>{{ data.courseType==1?"大学补习":"职业培训" }}</span>
        </el-form-item>
        <el-form-item label="课程">
          <span>{{ data.courseName }}</span>
        </el-form-item>

        <el-form-item label="仅限教务部可见" prop="isAcademicAffairsOnly">
          <el-checkbox v-model="model.isAcademicAffairsOnly" @change="onIsAcademicAffairsOnlyChange"/>
        </el-form-item>

        <el-form-item label="分享设置" prop="coursewareFileType">
          <el-select :disabled="model.isAcademicAffairsOnly" @change="oncoursewareTypeChange" v-model="model.coursewareFileType" placeholder="请选择分享设置">
            <el-option v-for="(item, index) in coursewareFileTypes" :key="index" :label="item.Value" :value="item.Key"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="对应课节" prop="courseActivationId" v-show="model.coursewareFileType === 2">
          <el-select :disabled="model.isAcademicAffairsOnly" v-model="model.courseActivationId" placeholder="请选择对应课节">
            <el-option v-for="(item, index) in courseActivations" :key="index" :label="item.Value" :value="item.Key"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传文件" prop="value">
          <div>
            <el-row v-for="(item, itemIndex) in model.fileList" :key="itemIndex">
              <el-col :span="14">
                <span class="course-file">
                  {{item.FileName}}
                </span>
              </el-col>
              <el-col :span="10">
                <span>{{item.CreateTime}}</span>
              </el-col>
            </el-row>
          </div>
          <el-button v-if="isAdded" type="primary" @click="uploadFile()">添加文件</el-button>
        </el-form-item>
        <el-dialog center title="上传课件" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="coursewareUploaderVisible" top="8vh"
          z-index="2000">
          <blobUploader @closeEditor="onCloseUploader" @blobUploadError="onUploadError" @blobUploaded="onUploaded" :type="9"
            :accepts="'.pdf,.html,.css,.js,.py,.c,.cc,.cpp,.rmd,.xls,.xlsx,.sas,.sql,.zip,.rar'" :maxNameLength="32" :isVisible="coursewareUploaderVisible"
            :isMulti="true" :isAutoSave="true"></blobUploader>
        </el-dialog>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="24" class="text-center">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="text-center" :span="24">
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="save()">{{ isAdded?'确认添加': '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-courseware-editor {
  color: black;
  h6 {
    font-weight: bold;
  }
  /deep/ .el-form-item__label {
    color: black;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .course-file {
    color: #2b94e0;
    span {
      padding-left: 1rem;
      color: #9c9c9c;
    }
  }
  .cs-file-remove {
    color: red;
    cursor: pointer;
  }
}
</style>

<script>
import {
  getCourseware,
  getCourseActivations,
  saveCourseware,
} from "../../service/courseware.service";
import blobUploader from "@/components/fileHandler/blobUploader";
let moment = require("moment");

export default {
  props: {
    data: {
      id: Number,
      week: Number,
      courseType: Number,
      courseName: String,
      courseId: Number,
      campusId: Number,
    },
    dialogVisible: false,
  },
  data() {
    let _self = this;
    let courseActivationIdValidator = (rule, value, callback) => {
      if (this.model.coursewareFileType === 2 && !this.model.isAcademicAffairsOnly && !value) {
        return callback(new Error("请选择课节"));
      }
      return callback();
    };

    return {
      model: {
        id: 0,
        week: 0,
        courseId: 0,
        campusId: 0,
        courseActivationId: "",
        coursewareFileType: 1,
        isAcademicAffairsOnly: false,
        fileList: [],
      },
      coursewareFileTypes: [],
      courseActivations: [],
      coursewareUploaderVisible: false,
      isReadonly: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      isAdded: false,
      showError: false,
      isLoadingCourseActivations: false,
      loading: false,
      errorMessage: "",
      rules: {
        courseActivationId: [
          {
            validator: courseActivationIdValidator,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    blobUploader,
  },
  created() {
    this.loadData();
  },
  methods: {
    loadCourseActivationsData() {
      this.isLoadingCourseActivations = true;
      getCourseActivations(
        this.data.courseId,
        this.data.campusId,
        this.data.week
      )
        .then((result) => {
          if (!!result && result.success) {
            this.courseActivations = result.data;
          } else {
            this.courseActivations = [];
          }
          this.isLoadingCourseActivations = false;
          this.loadCoursewareFileTypes();
        })
        .catch(() => {
          this.courseActivations = [];
          this.isLoadingCourseActivations = false;
        });
    },
    loadCoursewareFileTypes() {
      let list = [{ Key: 1, Value: "所有该班学生" }];
      if (this.courseActivations.length > 0) {
        list.push({ Key: 2, Value: "仅限出勤学生" });
      }
      this.coursewareFileTypes = list;
    },
    oncoursewareTypeChange() {
      if (this.model.coursewareFileType == 1) {
        this.model.courseActivationId = "";
      }
    },
    onIsAcademicAffairsOnlyChange(){

    },
    save() {
      if (this.model.fileList.length == 0) {
        this.errorMessage = "请上传至少一个文件";
        this.showError = true;
        return false;
      } else {
        this.errorMessage = "";
        this.showError = false;
      }
      if (!!this.$refs["model"]) {
        let isValid = true;
        this.$refs["model"].validate((valid) => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }

        this.submitBtnDisable = true;
        let result = saveCourseware(this.model).then((result) => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message("保存成功！");
            this.showError = false;
            this.$emit("saveSuccess");
            this.close();
          }
          this.submitBtnDisable = false;
        });
      }
    },
    close() {
      this.$emit("closeDialog");
    },
    loadData() {
      this.submitBtnDisable = false;
      if (!!this.data && !!this.data.id) {
        this.isAdded = false;

        this.loading = true;
        getCourseware(this.data.id)
          .then((result) => {
            if (!!result && result.success) {
              this.model.id = result.data.Id;
              this.model.courseActivationId = result.data.CourseActivationId;
              this.model.coursewareFileType = result.data.CoursewareFileType;
              this.model.isAcademicAffairsOnly = result.data.CoursewareManagementType === 1;
              this.model.fileList = result.data.FileList;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.isAdded = true;
        this.model.id = 0;
        this.model.coursewareFileType = 1;
        this.model.isAcademicAffairsOnly = false;
        this.model.courseActivationId = "";
        this.model.fileList = [];
      }
      this.model.week = this.data.week;
      this.model.courseId = this.data.courseId;
      this.model.campusId = this.data.campusId;
      this.loadCourseActivationsData();
    },
    closeUploader() {
      this.coursewareUploaderVisible = false;
    },
    uploadFile() {
      this.coursewareUploaderVisible = true;
    },
    onUploaded(data) {
      if (!!data) {
        data.forEach((item) => {
          this.model.fileList.push({
            FileStorageId: item.FileId,
            FileName: item.FileName,
            CreateTime: moment().format("lll"),
          });
        });
        this.errorMessage = "";
        this.showError = false;
      }
      this.coursewareUploaderVisible = false;
    },
    onUploadError() {},
    onCloseUploader() {},
    removeFile(file) {
      this.$confirm("您确认要删除该课件文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var index = this.model.fileList.findIndex((item) => {
            if (item.FileStorageId == file.FileStorageId) {
              return true;
            }
          });
          this.model.fileList.splice(index, 1);
        })
        .catch(() => {});
    },
  },
  watch: {
    data: function () {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/courseware/coursewareFileEditor.vue